/* eslint-disable */

import React, { useMemo, useState } from "react";
import moment from "moment";
import APIClient from "../client";
import Modal from "react-bootstrap/Modal";
import { Button, ButtonGroup, Spinner } from "react-bootstrap";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";
import { CSVLink } from "react-csv";

import LeafletMap from "../../shared/components/LeafletMap";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { Model, interpolate, OpenLayers, Cropr } from "../../shared/utils/legacy";

// const { SearchBar } = Search;

class DatasetDetailsModal extends React.Component {
  state = {
    loading: true,
    key: "general",
  };

  componentDidMount() {
    this.loadDetails();
    if (this.props.tab) {
      this.setState({ key: this.props.tab });
    }
  }

  async loadDetails() {
    let path = "/api/data/datasets/" + this.props.dataset.uuid + "/";
    let data = await APIClient.get(path, null, cropr.cloudfarm_oauth_token);
    this.setState({
      loading: false,
      data: data,
    });
  }

  render() {
    return (
      <Modal show={true} onHide={this.props.handleHide} dialogClassName="modal-xl">
        <Modal.Header closeButton>
          <Modal.Title>{gettext("Dataset details")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.loading ? (
            <div className="mx-auto" style={{ width: "300px" }}>
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Tabs activeKey={this.state.key} onSelect={(key) => this.setState({ key })}>
              <Tab eventKey="general" title={gettext("General")}>
                <DatasetGeneralDetails data={this.state.data} />
              </Tab>
              {this.state.data.extra_info ? (
                <Tab eventKey="task" title={gettext("Task")}>
                  <DatasetDetailsContent cols={cropr.getCloudFarmExtraInfo(this.state.data)} />
                </Tab>
              ) : null}
              <Tab eventKey="statistics" title={gettext("Statistics")}>
                <DatasetStatistics data={this.state.data} />
              </Tab>
              {this.state.key === "geometry" ? (
                <Tab eventKey="geometry" title={gettext("Geometry")}>
                  <DatasetGeometry data={this.state.data} handleReload={this.props.handleReload} />
                </Tab>
              ) : (
                <Tab eventKey="geometry" title={gettext("Geometry")}></Tab>
              )}
            </Tabs>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const DatasetGeneralDetails = (props) => {
  const dataset = props.data,
    cols = [];

  const [processedRecords, useProcessedRecords] = useState(null);
  let downloadFile = function (e) {
    e.preventDefault();
    const ds_id = dataset.uuid;
    APIClient.get(
      `/api/data/datasets/${ds_id}/download/`,
      null,
      cropr.cloudfarm_oauth_token
    ).then((res) => window.open(res, "_blank"));
  };

  let processDs = async function (e) {
    e.preventDefault();
    const ds_id = dataset.uuid;
    const response = await fetch(`/apps/cloudfarm/process_dataset/${ds_id}/`);
    const processed_records = await response.json();
    useProcessedRecords(processed_records);
    let notificationType = "info";
    let notificationMsg = gettext("No records created. ");
    if (dataset.data_set_rois.length === 0) {
      notificationMsg += gettext("First create fields please.");
    }
    if (Object.keys(processed_records).length > 0) {
      notificationType = "success";
      notificationMsg = interpolate(gettext("%s record(s) were created or updated."), [
        Object.keys(processed_records).length,
      ]);
    }
    cropr.notify(notificationType, notificationMsg);
  };
  const genCol = [[gettext("ID"), dataset.uuid]];
  if (dataset.name) {
    genCol.push([gettext("Name"), dataset.name]);
  }
  genCol.push([gettext("Data type"), dataset.data_type]);
  genCol.push([gettext("Start"), moment(dataset.recording_datetime).format(" LLLL")]);
  if (dataset.stopped_recording_datetime) {
    genCol.push([
      gettext("Duration"),
      moment
        .duration(
          moment(dataset.stopped_recording_datetime).diff(moment(dataset.recording_datetime))
        )
        .humanize(),
    ]);
  }
  if (dataset.source) {
    genCol.push([gettext("Source"), SOURCE_MAPPING[dataset.source]]);
  }
  if (dataset.data_format && dataset.data_format !== " n") {
    genCol.push([gettext("Data format"), DATA_FORMAT_MAPPING[dataset.data_format]]);
  }
  if (dataset.file) {
    genCol.push([
      gettext("File"),
      <a onClick={downloadFile} href="#">
        {dataset.file}
      </a>,
    ]);
  }
  genCol.push([gettext("Created"), moment(dataset.created).format(" LLLL")]);
  if (dataset.extra_info) {
    genCol.push([
      gettext("Automatic recording"),
      <a onClick={processDs} href="#">
        {gettext("(re)process")}
      </a>,
    ]);
  }
  cols.push(genCol);
  if (dataset.data_format && dataset.data_format !== " n") {
    dataset.data_set_rois.forEach(function (roi) {
      const cf = cropr.cropfields.findWhere({ did: roi.roi });
      if (cf) {
        const roiCol = [
          [gettext("Cropfield"), cf.get("name")],
          [
            gettext("Start"),
            moment(roi.recording_datetime || dataset.recording_datetime).format(" LLLL"),
          ],
        ];
        if (roi.stopped_recording_datetime) {
          roiCol.push([
            gettext("Duration"),
            moment
              .duration(moment(roi.stopped_recording_datetime).diff(moment(roi.recording_datetime)))
              .humanize(),
          ]);
        }
        roiCol.push([gettext("Overlap"), cropr.toLocaleFixed(roi.overlap_fraction * 100, 0) + "%"]);
        let recordId = processedRecords && processedRecords[cf.id];
        const record = cropr.records.findWhere({ dataset: dataset.uuid, cropfield: cf.id });
        if (!recordId && record) {
          recordId = record.id;
        }
        if (recordId) {
          roiCol.push([
            gettext("Record"),
            <a href={"/cropr/record/record/#edit/" + recordId} target="_blank">
              {gettext("Show record")}
            </a>,
          ]);
        }
        cols.push(roiCol);
      }
    });
  }
  return <DatasetDetailsContent cols={cols} />;
};

const DatasetStatistics = (props) => {
  const dataset = props.data;
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");

  const columnHelper = createColumnHelper();

  const nrFormatter = (value) => cropr.toLocaleFixed(value, 2) || "-";

  const columns = [
    columnHelper.accessor("name_description", {
      header: gettext("Measurement"),
      size: 150,
    }),
    columnHelper.accessor("unit", {
      header: gettext("Unit"),
    }),
    columnHelper.accessor("device_name", {
      header: gettext("Machine"),
      size: 100,
    }),
    columnHelper.accessor("min", {
      header: gettext("Min"),
      cell: (info) => nrFormatter(info.getValue()),
      meta: { align: "right" },
    }),
    columnHelper.accessor("max", {
      header: gettext("Max"),
      cell: (info) => nrFormatter(info.getValue()),
      meta: { align: "right" },
    }),
    columnHelper.accessor("mean", {
      header: gettext("Mean"),
      cell: (info) => nrFormatter(info.getValue()),
      meta: { align: "right" },
    }),
    columnHelper.accessor("std", {
      header: "Std",
      cell: (info) => nrFormatter(info.getValue()),
      meta: { align: "right" },
    }),
    columnHelper.accessor("count", {
      header: gettext("Count"),
      cell: (info) => nrFormatter(info.getValue()),
      meta: { align: "right" },
    }),
  ];

  // Add percentiles columns
  [0, 4, 9, 14, 18].forEach((i) => {
    columns.push(
      columnHelper.accessor((row) => (row.percentiles ? row.percentiles[i] : 0), {
        id: `percentiles${i}`,
        header: `${5 + i * 5}%`,
        cell: (info) => nrFormatter(info.getValue()),
        meta: { align: "right" },
      })
    );
  });

  // Add DDI column for specific users
  if (cropr.user && cropr.user.email && cropr.user.email.endsWith("crop-r.com")) {
    columns.splice(
      1,
      0,
      columnHelper.accessor("name", {
        header: "DDI",
      })
    );
  }

  const table = useReactTable({
    data: dataset.dataset_measurements || [],
    columns,
    state: {
      sorting,
      globalFilter,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  // Prepare CSV data
  const csvHeaders = columns.map((col) => ({
    label: typeof col.header === "function" ? col.header() : col.header,
    key: col.id || col.accessorKey,
  }));

  // Transform data for CSV export
  const csvData = dataset.dataset_measurements.map((item) => {
    const row = {};

    // Handle regular fields
    [
      "name_description",
      "unit",
      "device_name",
      "min",
      "max",
      "mean",
      "std",
      "count",
      "name",
    ].forEach((field) => {
      if (item[field] !== undefined) {
        row[field] = item[field];
      }
    });

    // Handle percentiles
    if (item.percentiles) {
      [0, 4, 9, 14, 18].forEach((i, idx) => {
        row[`percentiles${i}`] = item.percentiles[i];
      });
    }

    return row;
  });

  // CSV filename
  const csvFilename = `dataset-${dataset.uuid}-${new Date().toISOString().slice(0, 10)}.csv`;

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="dataTables_filter">
          <input
            className="form-control"
            placeholder={gettext("Search")}
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </div>
        <div className="dataTables_filter">
          <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename={csvFilename}
            className="btn btn-default btn-sm"
            target="_blank"
          >
            {gettext("Export to CSV")}
          </CSVLink>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    style={{
                      width: header.column.columnDef.size,
                      cursor: header.column.getCanSort() ? "pointer" : "default",
                      textAlign: header.column.columnDef.meta?.align || "left",
                    }}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {{
                      asc: " ^",
                      desc: " v",
                    }[header.column.getIsSorted()] ?? ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    style={{ textAlign: cell.column.columnDef.meta?.align || "left" }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2 align-items-center">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            {"<<"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            {"<"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            {">"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            {">>"}
          </button>
          <span>
            {gettext("Page")} {table.getState().pagination.pageIndex + 1} {gettext("of")}{" "}
            {table.getPageCount()}
          </span>
        </div>
        <select
          className="form-select form-select-sm w-auto"
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {gettext("Show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
      {dataset.data_type === "Fritzmeier" && (
        <a href="/apps/cloudfarm/generate_fritzmeier_csv/">
          {gettext("Download cropfield comparison")}
        </a>
      )}
    </>
  );
};

const DatasetDetailsContent = (props) => {
  return (
    <div className="row">
      {props.cols.map((col, j) => (
        <div className="col p-3 border-right" key={j}>
          {col.map((row, i) => (
            <div className="fieldset pb-2" key={i}>
              <label className="text-uppercase text-muted mb-0">{row[0]}</label>
              <div className={"text header" + (i === 0 ? " font-weight-bold" : "")}>{row[1]}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

class DatasetGeometry extends React.Component {
  state = {
    geoType: "concave_hull",
    importConcaveHullEnabled: true,
    importCropfieldEnabled: true,
    importWayLinesEnabled: false,
  };

  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this.setWayLines();
  }

  getIntersectingCropfields(wkt) {
    return this.getIntersectingFields(wkt, cropr.cropfields);
  }

  getIntersectingParcels(wkt) {
    return this.getIntersectingFields(wkt, cropr.parcels);
  }

  getIntersectingFields(wkt, collection) {
    const wkt_f = new OpenLayers.Format.WKT(),
      ds_geometry = wkt_f.read(wkt).geometry,
      intersecting_fields = [];

    collection.each(function (field) {
      if (!field.get("geometry")) return;
      const geometry = wkt_f.read(field.get("geometry")).geometry;
      if (
        ds_geometry.getBounds().intersectsBounds(geometry.getBounds()) &&
        ds_geometry.intersects(geometry)
      ) {
        intersecting_fields.push(field);
      }
    });
    return intersecting_fields;
  }

  setWayLines() {
    const dataset = this.props.data;
    this.newWayLines = [];
    if (!dataset.extra_info || !dataset.extra_info.partfield_lines) {
      return;
    }

    dataset.extra_info.partfield_lines.forEach((line) => {
      let geometry = line.geometry.split(";")[1],
        wayLine = new Model.WayLine({
          geometry: geometry,
          name: line.name,
          farm: cropr.farm.id,
          reference: dataset.uuid,
          manufacturer_code: this.extractManufacturerCode(),
          description: dataset.name,
          date: dataset.recording_datetime,
        });
      this.newWayLines.push(wayLine);
    });
    this.setState({ importWayLinesEnabled: this.newWayLines.length > 0 });
  }

  extractManufacturerCode() {
    const dataset = this.props.data;
    let manufacturerCode = "";
    if (dataset.extra_info && dataset.extra_info.devices) {
      Object.values(dataset.extra_info.devices).forEach((v) => {
        if (v.is_tractor) {
          manufacturerCode = v.manufacturer_code;
        }
      });
    } else if (dataset.source === "J") {
      //John Deere
      manufacturerCode = 33;
    }
    return manufacturerCode;
  }

  importGeometry = (geomType) => {
    const dataset = this.props.data;
    if (this.state.geoType === "way_lines") {
      this.newWayLines.forEach((wl) => {
        wl.save(
          {},
          {
            success: function (model, response) {
              let notificationType = "success",
                msg = "Created way line %s";
              if (model.get("updated") === true) {
                msg = "Updated way line %s";
              } else if (model.get("updated") === false) {
                msg = "Way line %s already exists";
                notificationType = "info";
              }
              cropr.notify(notificationType, interpolate(gettext(msg), [wl.get("name")]));
            },
            error: function (model, response) {
              cropr.notify(
                "danger",
                interpolate(gettext("Could not create way line %s"), [wl.get("name")])
              );
            },
          }
        );
      });
      this.setState({ importWayLinesEnabled: false });
    } else if (geomType === "parcel") {
      const ewkt =
        this.state.geoType === "concave_hull"
          ? dataset.concave_hull
          : dataset.extra_info.partfield_geometry;
      const wkt = ewkt.split(";")[1];
      const intersectingParcels = this.getIntersectingParcels(wkt);
      if (intersectingParcels.length > 1) {
        cropr.notify(
          "danger",
          interpolate(gettext("geometry intersects with parcels (%s), could not import"), [
            intersectingParcels.map((field) => field.get("name")).join(","),
          ])
        );
      } else {
        let success_message, parcel;
        if (intersectingParcels.length === 1) {
          success_message = gettext("Parcel updated");
          parcel = intersectingParcels[0];
          parcel.set({ geometry: wkt });
          let area = this.getArea(wkt);
          parcel.set({ registered_area: area });
        } else {
          success_message = gettext("Parcel created");
          parcel = new Model.Parcel({
            geometry: wkt,
            farm: cropr.farm.id,
          });
          this.setFieldName(dataset, parcel);
        }
        parcel.save(
          {},
          {
            success: function (model, response) {
              cropr.notify("success", success_message);
              if (!cropr.parcels.get(model.id)) {
                cropr.parcels.add(model);
              }
            },
          }
        );
      }
    } else {
      const ewkt =
        this.state.geoType === "concave_hull"
          ? dataset.concave_hull
          : dataset.extra_info.partfield_geometry;
      const wkt = ewkt.split(";")[1];
      const intersectingCropFields = this.getIntersectingCropfields(wkt);
      if (intersectingCropFields.length > 1) {
        cropr.notify(
          "danger",
          interpolate(gettext("geometry intersects with cropfields (%s), could not import"), [
            intersectingCropFields.map((field) => field.get("name")).join(","),
          ])
        );
      } else {
        let success_message, cropfield;
        if (intersectingCropFields.length === 1) {
          success_message = gettext("Cropfield updated");
          cropfield = intersectingCropFields[0];
          cropfield.set({ geometry: wkt });
          let area = this.getArea(wkt);
          cropfield.set({ registered_area: area, reference: "GPS" });
        } else {
          success_message = gettext("Cropfield created");
          const activePlan = cropr.getActivePlan();
          cropfield = new Model.CropField({
            geometry: wkt,
            plan: activePlan.id,
            farm: cropr.farm.id,
            period_start: activePlan.get("period_start"),
            period_end: activePlan.get("period_end"),
            reference: "GPS",
          });
          this.setFieldName(dataset, cropfield);
        }
        const that = this;
        cropfield.save(
          {},
          {
            success: function (model, response) {
              cropr.notify("success", success_message);
              if (!cropr.cropfields.get(model.id)) {
                cropr.cropfields.add(model);
              }
              that.props.handleReload(4000);
            },
          }
        );
      }
    }
  };

  setFieldName(dataset, field) {
    let cropfield_name;
    if (dataset.extra_info && dataset.extra_info.partfield_name) {
      cropfield_name = dataset.extra_info.partfield_name;
    } else {
      cropfield_name = field.generateName();
    }
    field.set({ name: cropfield_name });
  }

  getArea(wkt) {
    let wkt_f = new OpenLayers.Format.WKT();
    let field = wkt_f.read(wkt);
    let area = Cropr.getArea_m2(field) / 10000;
    return area;
  }

  render() {
    const dataset = this.props.data;
    const locations = [];
    let importEnabled = false;
    if (this.state.geoType === "concave_hull" && dataset.concave_hull) {
      locations.push({ type: "geometry", wkt: dataset.concave_hull.split(";")[1], zoomTo: true });
      importEnabled = this.state.importConcaveHullEnabled;
    }
    if (this.state.geoType === "cropfield") {
      locations.push({
        type: "geometry",
        wkt: dataset.extra_info.partfield_geometry.split(";")[1],
        zoomTo: true,
        toolTip: dataset.extra_info.partfield_name,
      });
      importEnabled = this.state.importCropfieldEnabled;
    }
    if (this.state.geoType === "way_lines") {
      dataset.extra_info.partfield_lines.forEach((line) => {
        locations.push({
          type: "geometry",
          wkt: line.geometry.split(";")[1],
          zoomTo: true,
          toolTip: line.name,
          line: true,
        });
      });
      importEnabled = this.state.importWayLinesEnabled;
    }

    return (
      <>
        <LeafletMap locations={locations} height="calc(100vh/2)" />
        <ButtonGroup className="float-left" aria-label="geometry">
          <Button
            variant={this.state.geoType === "concave_hull" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "concave_hull" })}
          >
            {gettext("Circumference of measurements")}
          </Button>
          <Button
            variant={this.state.geoType === "cropfield" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "cropfield" })}
            disabled={!(dataset.extra_info && dataset.extra_info.partfield_geometry)}
          >
            {gettext("Field")}
          </Button>
          <Button
            variant={this.state.geoType === "way_lines" ? "primary" : ""}
            onClick={(e) => this.setState({ geoType: "way_lines" })}
            disabled={
              !(
                dataset.extra_info &&
                dataset.extra_info.partfield_lines &&
                dataset.extra_info.partfield_lines.length > 0
              )
            }
          >
            {gettext("Way lines")}
          </Button>
        </ButtonGroup>
        <Button className="float-right m-1" disabled={!importEnabled} onClick={this.importGeometry}>
          {
            {
              concave_hull: gettext("Import as cropfield"),
              cropfield: gettext("Import as cropfield"),
              way_lines: gettext("Import way lines"),
            }[this.state.geoType]
          }
        </Button>
        {this.state.geoType === "cropfield" || this.state.geoType === "concave_hull" ? (
          <Button
            className="float-right m-1"
            disabled={!importEnabled}
            onClick={() => this.importGeometry("parcel")}
          >
            {gettext("Import as parcel")}
          </Button>
        ) : null}
      </>
    );
  }
}

const SOURCE_MAPPING = {
  U: gettext("Upload"),
  D: "Dropbox",
  A: "AGCO",
  J: "John Deere",
  I: gettext("Shared"),
  C: "CLAAS",
  DW: "Dronewerkers",
  LG: "LoonwerkGPS",
};
const DATA_FORMAT_MAPPING = {
  p: gettext("Points"),
  r: gettext("Raster"),
  g: gettext("Polygons"),
  m: gettext("Multipolygons"),
  n: "-",
  e: "-",
};
export default DatasetDetailsModal;
